export const enums = {
    RESUME: "RESUME",
    PAUSE: "PAUSE",
    VALIDATOR: "VALIDATOR",
    BARTENDER: "BARTENDER",
    BANKER: "BANKER",
    GOD: "GOD",
    ADMIN: "ADMIN",
    WALLET: "WALLET"

}
